import { render, staticRenderFns } from "./WaitSendStockLists.vue?vue&type=template&id=47603a9e&"
import script from "./WaitSendStockLists.vue?vue&type=script&lang=js&"
export * from "./WaitSendStockLists.vue?vue&type=script&lang=js&"
import style0 from "./WaitSendStockLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports